(function () {
  'use strict';

  var turnstileWidgetId = null;
  var WEBHOOK_URL = 'https://automation.ethicalhq.com/webhook/2dd921cf-5d82-412c-a4dc-205e1d62e795';
  var THANK_YOU_URL = '/pages/thank-you-contact';
  var EMAILABLE_API_KEY = 'live_77cf6e9b8b568e336d63';

  /* =========================
     Init
  ========================== */
  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('Contact-Us-Form');
    if (!form) return;

    var hasTurnstile = window.turnstile && window.TURNSTILE_SITE_KEY;

    if (hasTurnstile) {
      var container = form.querySelector('.turnstile-container');
      if (container) {
        turnstile.ready(function () {
          turnstileWidgetId = turnstile.render(container, {
            sitekey: window.TURNSTILE_SITE_KEY,
            size: 'invisible',
            execution: 'execute',
            action: 'contact_us_form',
            callback: onTurnstileSuccess,
            'error-callback': onTurnstileError
          });
        });
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        handleContactFormSubmit(form);
      }, true);

    } else {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        handleDirectSubmit(form);
      }, true);
    }
  });

  /* =========================
     Turnstile path
  ========================== */
  function handleContactFormSubmit(form) {
    var email = getField(form, '#Email-Address');
    var message = getField(form, '#Message');

    if (!email) { showStatus(form, 'error', 'Email is required'); return; }
    if (!isValidEmailFormat(email)) { showStatus(form, 'error', 'Please enter a valid email address'); return; }
    if (!message) { showStatus(form, 'error', 'Message is required'); return; }

    var submitBtn = form.querySelector('[type="submit"]');
    setLoading(submitBtn, true, 'Verifying\u2026');

    if (!turnstileWidgetId) {
      showStatus(form, 'error', 'Verification unavailable. Please refresh and try again.');
      setLoading(submitBtn, false);
      return;
    }

    turnstile.execute(turnstileWidgetId);
  }

  function onTurnstileSuccess(token) {
    var form = document.getElementById('Contact-Us-Form');
    if (!form) return;

    var tokenInput = form.querySelector('[name="turnstile_token"]');
    if (tokenInput) tokenInput.value = token;

    submitForm(form, token);
  }

  function onTurnstileError() {
    var form = document.getElementById('Contact-Us-Form');
    showStatus(form, 'error', 'Verification failed. Please try again.');
    var submitBtn = form ? form.querySelector('[type="submit"]') : null;
    setLoading(submitBtn, false);
  }

  /* =========================
     Direct path (no Turnstile)
  ========================== */
  function handleDirectSubmit(form) {
    var email = getField(form, '#Email-Address');
    var message = getField(form, '#Message');

    if (!email) { showStatus(form, 'error', 'Email is required'); return; }
    if (!isValidEmailFormat(email)) { showStatus(form, 'error', 'Please enter a valid email address'); return; }
    if (!message) { showStatus(form, 'error', 'Message is required'); return; }

    var submitBtn = form.querySelector('[type="submit"]');
    setLoading(submitBtn, true, 'Sending\u2026');

    submitForm(form, null);
  }

  /* =========================
     Core submit
  ========================== */
  function submitForm(form, token) {
    var submitBtn = form.querySelector('[type="submit"]');
    var firstName = getField(form, '#First-Name');
    var lastName = getField(form, '#Last-Name');
    var email = getField(form, '#Email-Address');
    var message = getField(form, '#Message');

    validateWithEmailable(email)
      .then(function (isValid) {
        if (!isValid) {
          throw new Error('Please check your email address and try again.');
        }

        var payload = {
          firstName: firstName,
          lastName: lastName,
          email: email,
          message: message,
          formName: 'Contact Us',
          context: {
            pageUri: window.location.href,
            pageName: document.title
          }
        };

        var hutk = getHubspotUTK();
        if (hutk) payload.context.hutk = hutk;
        if (token) payload.turnstile_token = token;

        return sendToWebhook(payload);
      })
      .then(function () {
        window.location.href = THANK_YOU_URL;
      })
      .catch(function (err) {
        showStatus(form, 'error', err.message || 'Something went wrong. Please try again.');
        setLoading(submitBtn, false);
        if (turnstileWidgetId) {
          try { turnstile.reset(turnstileWidgetId); } catch (e) {}
        }
      });
  }

  /* =========================
     Webhook
  ========================== */
  function sendToWebhook(payload) {
    if (!WEBHOOK_URL) {
      throw new Error('Webhook URL is not configured. Please set it in the theme editor.');
    }
    return fetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error('Submission failed. Please try again.');
    });
  }

  /* =========================
     Emailable
  ========================== */
  function validateWithEmailable(email) {
    if (!EMAILABLE_API_KEY) return Promise.resolve(true);

    return fetch(
      'https://api.emailable.com/v1/verify?email=' + encodeURIComponent(email) + '&api_key=' + EMAILABLE_API_KEY
    ).then(function (res) {
      if (!res.ok) return true;
      return res.json().then(function (data) {
        return data.state !== 'undeliverable';
      });
    }).catch(function () {
      return true;
    });
  }

  /* =========================
     HubSpot UTK
  ========================== */
  function getHubspotUTK() {
    var m = document.cookie.match(/hubspotutk=([^;]+)/);
    return m ? m[1] : '';
  }

  /* =========================
     Status message
  ========================== */
  function showStatus(form, type, message) {
    if (!form) return;
    var el = document.getElementById('contact-form-status');
    if (!el) return;
    el.textContent = message;
    el.className = 'cn-form-status cn-form-status--' + type;
    el.style.display = 'block';
    el.setAttribute('role', 'alert');
  }

  /* =========================
     Helpers
  ========================== */
  function getField(form, selector) {
    var el = form.querySelector(selector);
    return el ? el.value.trim() : '';
  }

  function isValidEmailFormat(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function setLoading(btn, state, text) {
    if (!btn) return;
    if (state) {
      btn.dataset.originalText = btn.textContent;
      btn.textContent = text || 'Sending\u2026';
      btn.disabled = true;
      btn.style.opacity = '0.6';
    } else {
      btn.textContent = btn.dataset.originalText || 'Submit';
      btn.disabled = false;
      btn.style.opacity = '1';
    }
  }

})();
